export default __webpack_public_path__ + "static/media/walken_banner.84ae664f.jpeg";